export default __webpack_public_path__ + "static/responsiveness-0b22a4e600f65dcacdf47f0f7876aa4d.mp4";